import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { JUNE_2026_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(JUNE_2026_CAMPAIGN_END_DATE);
